let getters = {
    user(state) {
        return state.user
    },
    nav(state) {
        return state.nav
    },
    isAuthenticated(state) {
        return state.user.token !== null
    }
}

export default getters